
import { useState } from 'react';

export default function AddOnServicesSection() {
  const [activeTab, setActiveTab] = useState(0);

  const addOns = [
    {
      title: 'A.I. Web Design Add-On',
      description: 'Redesign your website with intelligent automation built in — optimized for conversion, lead capture, and chatbot engagement.',
      features: [
        'Conversion-optimized design',
        'Built-in chatbot integration',
        'Lead capture automation',
        'Mobile-responsive layouts',
        'A/B testing capabilities'
      ],
      image: 'https://public.readdy.ai/ai/img_res/cd162c27a9a8d032183a4fe7b689f3b4.jpg'
    },
    {
      title: 'A.I. Lead Generation Add-On',
      description: 'Deploy advanced A.I. prospecting that identifies, qualifies, and books high-intent leads for your agency.',
      features: [
        'Advanced lead scoring',
        'Automated prospecting',
        'Qualification workflows',
        'Appointment booking',
        'CRM integration'
      ],
      image: 'https://readdy.ai/api/search-image?query=Advanced%20lead%20generation%20dashboard%20with%20AI%20prospecting%20tools%2C%20modern%20sales%20analytics%20interface%2C%20automated%20lead%20qualification%20system%2C%20professional%20business%20development%20workspace%2C%20CRM%20integration%20visualization%2C%20data-driven%20sales%20environment&width=600&height=400&seq=lead-gen-addon&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Add-On Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Enhance your A.I. deployment with specialized services designed to maximize your return on investment.
          </p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row gap-2 mb-8">
            {addOns.map((addOn, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeTab === index
                    ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                    : 'bg-white text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                {addOn.title}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {addOns[activeTab].title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {addOns[activeTab].description}
              </p>
              
              <ul className="space-y-3">
                {addOns[activeTab].features.map((feature, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="relative">
              <img 
                src={addOns[activeTab].image}
                alt={addOns[activeTab].title}
                className="w-full h-80 object-cover rounded-xl shadow-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
